export default __webpack_public_path__ + "static/media/iconPrivacidad.d212437b.svg";